"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a, _b, _c, _d, _e, _f;
Object.defineProperty(exports, "__esModule", { value: true });
exports.KnowledgePicker = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const events_1 = require("@front/event/events");
const WSService_audio_1 = __importStar(require("@front/services/WSService.audio"));
const SignalService_1 = __importStar(require("@front/services/SignalService"));
const PopupService_1 = __importStar(require("@front/services/PopupService"));
const helpers_1 = require("./helpers");
//@ts-ignore                
let rwsTemplate = T.html `<div id="knowledge-picker" class="${x => x.forcedShow === 'false' && x.showKnowledgeSection ? 'shown-picker' : ''}">
  ${(0, fast_element_1.when)(x => x.forcedShow !== 'true', (0, fast_element_1.html) `<div class="form-group">
    <div class="kdb-button-container">
      <button type="button" @click="${(x, c) => x.toggleKnowledgeSection.bind(x)(c.event)}"
        class="kdb-button btn btn-primary">
        <rws-tooltip side="left" text="${'config.tooltips.chat.pick.kdb'.t()}">
          <i class="simple-icon-book-open"></i>
        </rws-tooltip>
      </button>
      ${(0, fast_element_1.when)(x => x.selectedIdsArray.length > 0, (0, fast_element_1.html) `<span class="badge badge-success kdb-count-badge">${x => x.selectedIdsArray.length}</span>`)}
    </div>
  </div>`)}
  ${(0, fast_element_1.when)(x => x.absolute && x.showKnowledgeSection, (0, fast_element_1.html) `<div @click="${x => x.close()}" class="backdrop"></div>`)}

  <div class="knowledge-section${x => x.absolute ? ' is-abs' : ''}${x => x.isBottomPosition ? ' bottom-position' : ''}"
    ?hidden="${x => !x.showKnowledgeSection}">
    <div class="knowledge-header">
      <p><rws-tooltip text="${'knowledge.picker.tooltip'.t()}">
          <strong>${'avatar.form.knowledge.label'.t()}</strong>
        </rws-tooltip></p>
      <button type="button" class="btn btn-outline-primary btn-sm add-knowledge-btn"
        @click="${(x, c) => x.openKnowledgeModal.bind(x)()}" title="${'avatar.form.knowledge.add'.t()}">
        ${'route.knowledge.create'.t()} <i class="simple-icon-plus"></i>
      </button>
    </div>

    
    <div class="search-mode-section">
      <part-radio label="knowledge.picker.search.mode" name="search-mode" :options="${x => x.searchModeOptions}"
        :value="${x => x.searchMode}" :onChange="${x => x.onSearchModeChange}">
      </part-radio>
    </div>

    ${(0, fast_element_1.when)(x => x.absolute, (0, fast_element_1.html) `<div class="picker-options">
      <rws-tooltip text="${'kdb.fullscan_tooltip'.t()}" side="top">
        <input id="picker_fullscan" type="checkbox" class="fullscan-show__checkbox" :checked="${x => x.fullscan}"
          @change="${(x, c) => x.toggleFullscan.bind(x)(c.event)}" /></rws-tooltip>
      <label for="picker_fullscan" class="knowledge-show__label">
        ${'avatar.form.knowledge.fullscan'.t()}
      </label>
    </div>`)}

    
    ${(0, fast_element_1.when)(x => x.searchMode === 'projects' && x.selectedProjects.length > 0, (0, fast_element_1.html) `
    <div class="selected-items-flex">
      <h6 class="table-title">${'knowledge.picker.selected.projects'.t()}</h6>
      <div class="flex-table">
        <div class="flex-table-header">
          <div class="flex-cell name-col">${'knowledge.picker.table.name'.t()}</div>
          <div class="flex-cell description-col">${'knowledge.picker.table.description'.t()}</div>
          <div class="flex-cell action-col"></div>
        </div>
        <div class="flex-table-body">
          ${(0, fast_element_1.repeat)(x => x.selectedProjects, (0, fast_element_1.html) `
          <div class="flex-table-row">
            <div class="flex-cell name-col project-name" title="${project => project.name}">${project => project.name}
            </div>
            <div class="flex-cell description-col project-description" title="${project => project.description || ''}">
              ${(0, fast_element_1.when)(x => x.description, (0, fast_element_1.html) `${project => project.description}`, (0, fast_element_1.html) `<span
                class="text-muted">-</span>`)}
            </div>
            <div class="flex-cell action-col">
              <button type="button" class="btn btn-sm btn-outline-danger remove-btn"
                @click="${(project, c) => c.parent.removeProject(project)}" title="${'knowledge.picker.remove'.t()}">
                <i class="simple-icon-close"></i>
              </button>
            </div>
          </div>
          `)}
        </div>
      </div>
    </div>
    `)}

    <div class="search-container">
      <label class="search-label">
        ${(0, fast_element_1.when)(x => x.searchMode === 'knowledge', (0, fast_element_1.html) `${'knowledge.picker.search.knowledge.label'.t()}`)}
        ${(0, fast_element_1.when)(x => x.searchMode === 'projects', (0, fast_element_1.html) `${'knowledge.picker.search.projects.label'.t()}`)}
      </label>
      <div class="search-input-container">
        <input type="text" class="form-control knowledge-search"
          placeholder="${x => x.searchMode === 'knowledge' ? 'knowledge.picker.search.knowledge.placeholder'.t() : 'knowledge.picker.search.projects.placeholder'.t()}"
          :value="${x => x.knowledgeSearchTerm}" :disabled="${x => !x.showKnowledgeSection}"
          @input="${(x, c) => x.onKnowledgeSearchInput(c.event)}" @focus="${x => x.onKnowledgeSearchFocus()}"
          @blur="${x => x.onKnowledgeSearchBlur()}" />
        ${(0, fast_element_1.when)(x => x.knowledgeSearchTerm && x.knowledgeSearchTerm.length > 0, (0, fast_element_1.html) `
          <button type="button" class="btn btn-sm btn-outline-secondary search-clear-btn"
            @click="${x => x.clearSearch()}" title="${'knowledge.picker.search.clear'.t()}">
            <i class="simple-icon-close"></i>
          </button>
        `)}
      </div>


      
      ${(0, fast_element_1.when)(x => x.searchMode === 'knowledge', (0, fast_element_1.html) `
      <div class="knowledge-dropdown" ?hidden="${x => !x.showKnowledgeDropdown}">
        ${(0, fast_element_1.repeat)(x => x.filteredKnowledgeEntries, (0, fast_element_1.html) `
        <div class="knowledge-option" @click="${(knowledge, c) => c.parent.onKnowledgeSelect(knowledge)}">
          <div class="knowledge-type"><span class="badge badge-info">${knowledge => knowledge.contentType}</span></div>
          <div class="knowledge-title">${knowledge => knowledge.title}</div>          
          <div class="knowledge-info">
            ${(0, fast_element_1.when)(x => x.project, (0, fast_element_1.html) `<span class="badge badge-warning mr-1">${x => x.project.name}</span>`)}

            ${(0, fast_element_1.when)(x => x.tags, (0, fast_element_1.html) `${(0, fast_element_1.repeat)(x => x.tags, (0, fast_element_1.html) `<span class="badge badge-secondary mr-1">${x => x}</span>`)}`)}
          </div>
        </div>
        `)}
        ${(0, fast_element_1.when)(x => x.filteredKnowledgeEntries.length === 0, (0, fast_element_1.html) `
        <div class="dropdown-empty-state">
          <i class="simple-icon-magnifier"></i>
          <span>${'knowledge.picker.no.results'.t()}</span>
        </div>
        `)}
      </div>
      `)}

      
      ${(0, fast_element_1.when)(x => x.searchMode === 'projects', (0, fast_element_1.html) `
      <div class="knowledge-dropdown" ?hidden="${x => !x.showKnowledgeDropdown}">
        ${(0, fast_element_1.repeat)(x => x.filteredProjects, (0, fast_element_1.html) `
        <div class="project-option" @click="${(project, c) => c.parent.onProjectSelect(project)}">
          <div class="project-title">${project => project.name}</div>
          ${(0, fast_element_1.when)(x => x.description, (0, fast_element_1.html) `<div class="project-description">${project => project.description}</div>`)}
        </div>
        `)}
        ${(0, fast_element_1.when)(x => x.filteredProjects.length === 0, (0, fast_element_1.html) `
        <div class="dropdown-empty-state">
          <i class="simple-icon-magnifier"></i>
          <span>${'knowledge.picker.no.results'.t()}</span>
        </div>
        `)}
      </div>
      `)}
    </div>


    ${(0, fast_element_1.when)(x => x.selectedKnowledge.length, (0, fast_element_1.html) `
    <div class="selected-items-flex">
      <h6 class="table-title">${'knowledge.picker.selected.knowledge'.t()}</h6>
      <div class="flex-table">
        <div class="flex-table-header">
          <div class="flex-cell name-col">${'knowledge.picker.table.name'.t()}</div>
          <div class="flex-cell project-col">${'knowledge.picker.table.project'.t()}</div>
          <div class="flex-cell format-col">${'knowledge.picker.table.format'.t()}</div>
          <div class="flex-cell status-col" style="position: relative; z-index: 5;">${'knowledge.ragStatus'.t()}</div>
          <div class="flex-cell mode-col">${'knowledge.picker.1to1mode'.t()}</div>
          <div class="flex-cell action-col"></div>
        </div>
        <div class="flex-table-body">
          ${(0, fast_element_1.repeat)(x => x.selectedKnowledge, (0, fast_element_1.html) `
          <div class="flex-table-row">
            <div class="flex-cell name-col knowledge-name" title="${knowledge => knowledge.title}">${knowledge => knowledge.title}</div>
            <div class="flex-cell project-col knowledge-project">
              ${(0, fast_element_1.when)(x => x.project, (0, fast_element_1.html) `<span class="badge badge-warning">${x => x.project.name}</span>`, (0, fast_element_1.html) `<span
                class="text-muted">-</span>`)}
            </div>
            <div class="flex-cell format-col knowledge-format">
              <span class="badge badge-info">${(knowledge, c) => { var _a; return c.parent.formatFileType(knowledge.contentType, (_a = knowledge.file) === null || _a === void 0 ? void 0 : _a.mimeType); }}</span>
            </div>
            <div class="flex-cell status-col knowledge-status">
              ${(0, fast_element_1.when)(x => x.ragStatus === 'processing' || x.ragStatus === 'pending', (0, fast_element_1.html) `
                <span class="badge badge-info">${(knowledge) => ('knowledge.ragStatus.' + knowledge.ragStatus).t()}${(knowledge, c) => c.parent.showItemPercentage(knowledge.id)}</span>
              `)}
              ${(0, fast_element_1.when)(x => x.ragStatus === 'completed', (0, fast_element_1.html) `
                <span class="badge badge-success">${(knowledge) => ('knowledge.ragStatus.' + knowledge.ragStatus).t()}</span>
              `)}
              ${(0, fast_element_1.when)(x => x.ragStatus === 'not_indexed', (0, fast_element_1.html) `
                <span class="badge badge-success">${(knowledge) => ('knowledge.ragStatus.' + knowledge.ragStatus).t()}</span>
              `)}
              ${(0, fast_element_1.when)(x => x.ragStatus === 'failed', (0, fast_element_1.html) `
                <span class="badge badge-danger">${(knowledge) => ('knowledge.ragStatus.' + knowledge.ragStatus).t()}</span>
              `)}
            </div>
            <div class="flex-cell mode-col">
              <part-switch 
                name="oneToOne_${knowledge => knowledge.id}" 
                ?disabled="${(knowledge, c) => knowledge.contentType === 'text' || knowledge.ragStatus === 'processing' || knowledge.ragStatus === 'pending'}"
                :value="${(knowledge, c) => knowledge.contentType === 'text' ? true : c.parent.isKnowledgeInFullMode(knowledge.id.toString())}"
                @click="${(knowledge, c) => c.parent.toggleKnowledgeFullMode(knowledge.id.toString(), c.event)}">
              </part-switch>
            </div>
            <div class="flex-cell action-col">
              <button type="button" class="btn btn-sm btn-outline-danger remove-btn"
                @click="${(knowledge, c) => c.parent.removeKnowledge(knowledge.id.toString())}"
                title="${'knowledge.picker.remove'.t()}">
                <i class="simple-icon-close"></i>
              </button>
            </div>
          </div>
          `)}
        </div>
      </div>
    </div>    
    `)}
    
    ${(0, fast_element_1.when)(x => x.loading && !x.selectedKnowledge.length, (0, fast_element_1.html) `
      <div class="dropdown-loading-state">
        <app-loader></app-loader>
      </div>
    `)}
  </div>
</div>`;
require("./styles/layout.scss");
const styles = T.css `:host {
  display: block;
}

#knowledge-picker.shown-picker {
  display: block;
  position: sticky;
  top: 50px;
}
#knowledge-picker .form-group {
  margin-bottom: 1rem;
  position: relative;
}
#knowledge-picker .form-group .kdb-button-container {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  position: relative;
}
#knowledge-picker .form-group .kdb-button-container .kdb-count-badge {
  font-size: 0.75rem;
  padding: 0.15rem 0.15rem;
  border-radius: 0.5rem;
  font-weight: 600;
  min-width: 1.5rem;
  text-align: center;
  line-height: 1;
  background-color: #28a745;
  color: white;
  border: 1px solid #1e7e34;
  box-shadow: 0 1px 2px rgba(40, 167, 69, 0.2);
  position: absolute;
  right: -10px;
  bottom: -10px;
}
#knowledge-picker .form-group .kdb-button-container .kdb-count-badge.badge-success {
  background-color: #28a745;
  color: white;
  border-color: #1e7e34;
}
#knowledge-picker .form-group .knowledge-show__checkbox {
  position: absolute;
  top: 0.25rem;
  left: 0;
  z-index: 2;
  width: 13px;
  height: 13px;
  margin: 0;
  opacity: 0;
  cursor: pointer;
}
#knowledge-picker .form-group .knowledge-show__label {
  display: inline-block;
  font-size: 0.875rem;
  color: #6c757d;
  cursor: pointer;
  padding-left: 1.5rem;
  margin-bottom: 0;
  position: relative;
  font-weight: 500;
}
#knowledge-picker .form-group .knowledge-show__label::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  width: 13px;
  height: 13px;
  pointer-events: none;
  background-color: #fff;
  border: 1px solid #adb5bd;
  border-radius: 0.25em;
}
#knowledge-picker .form-group .knowledge-show__label::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  width: 13px;
  height: 13px;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 0.5em 0.5em;
  opacity: 0;
  transition: opacity 0.15s ease-in-out;
}
#knowledge-picker .form-group .knowledge-show__checkbox:checked ~ .knowledge-show__label::before {
  color: #fff;
  border-color: #2F2E2D;
  background-color: #2F2E2D;
}
#knowledge-picker .form-group .knowledge-show__checkbox:checked ~ .knowledge-show__label::after {
  opacity: 1;
  background-color: white;
  mask: url("/assets/images/check.svg") no-repeat center center;
  mask-size: 0.5em 0.5em;
  -webkit-mask: url("/assets/images/check.svg") no-repeat center center;
  -webkit-mask-size: 0.5em 0.5em;
}
#knowledge-picker .form-group .knowledge-show__checkbox:focus ~ .knowledge-show__label::before {
  border-color: #86b7fe;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
#knowledge-picker .form-group .picker-options {
  margin-bottom: 1rem;
  padding: 0.5rem 0.75rem;
  background-color: #e9ecef;
  border-radius: 0.375rem;
  border: 1px solid #dee2e6;
}
#knowledge-picker .form-group .picker-options .fullscan-show__checkbox {
  position: absolute;
  top: 0.25rem;
  left: 0;
  z-index: 2;
  width: 15px;
  height: 15px;
  margin: 0;
  opacity: 0;
  cursor: pointer;
}
#knowledge-picker .form-group .picker-options .knowledge-show__label {
  display: inline-block;
  font-size: 0.875rem;
  color: #495057;
  cursor: pointer;
  padding-left: 1.75rem;
  margin-bottom: 0;
  position: relative;
  font-weight: 500;
}
#knowledge-picker .form-group .picker-options .knowledge-show__label::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  width: 15px;
  height: 15px;
  pointer-events: none;
  background-color: #fff;
  border: 2px solid #adb5bd;
  border-radius: 0.25em;
}
#knowledge-picker .form-group .picker-options .knowledge-show__label::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  width: 15px;
  height: 15px;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 0.6em 0.6em;
  opacity: 0;
  transition: opacity 0.15s ease-in-out;
}
#knowledge-picker .form-group .picker-options .fullscan-show__checkbox:checked ~ .knowledge-show__label::before {
  color: #fff;
  border-color: #007bff;
  background-color: #007bff;
}
#knowledge-picker .form-group .picker-options .fullscan-show__checkbox:checked ~ .knowledge-show__label::after {
  opacity: 1;
  background-color: white;
  mask: url("/assets/images/check.svg") no-repeat center center;
  mask-size: 0.6em 0.6em;
  -webkit-mask: url("/assets/images/check.svg") no-repeat center center;
  -webkit-mask-size: 0.6em 0.6em;
}
#knowledge-picker .form-group .picker-options .fullscan-show__checkbox:focus ~ .knowledge-show__label::before {
  border-color: #86b7fe;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
#knowledge-picker .backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0);
}
#knowledge-picker .knowledge-section.is-abs {
  position: fixed;
  width: 680px;
  max-width: 95vw;
  max-height: 80vh;
  background: #FFF;
  padding: 20px;
  border-radius: 12px;
  border: 1px solid #e3e6f0;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  overflow-y: auto;
  z-index: 1050;
}
#knowledge-picker .knowledge-section[hidden] {
  display: none;
}
#knowledge-picker .knowledge-section .knowledge-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}
#knowledge-picker .knowledge-section .knowledge-header p {
  margin: 0;
}
#knowledge-picker .knowledge-section .knowledge-header .add-knowledge-btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
  line-height: 1.2;
}
#knowledge-picker .knowledge-section .knowledge-header .add-knowledge-btn i {
  font-size: 0.7rem;
}
#knowledge-picker .knowledge-section p {
  margin-bottom: 1rem;
}
#knowledge-picker .knowledge-section .search-mode-section {
  margin-bottom: 1rem;
  padding: 0.75rem;
  background-color: #f8f9fa;
  border-radius: 0.5rem;
  border: 1px solid #e9ecef;
}
#knowledge-picker .knowledge-section .search-mode-section part-radio .radio-group {
  display: flex;
  flex-direction: row;
  gap: 1.5rem;
}
#knowledge-picker .knowledge-section .search-mode-section part-radio .form-check {
  display: flex;
  align-items: center;
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  transition: background-color 0.2s;
}
#knowledge-picker .knowledge-section .search-mode-section part-radio .form-check:hover {
  background-color: rgba(0, 123, 255, 0.05);
}
#knowledge-picker .knowledge-section .search-mode-section part-radio .form-check-input {
  margin-right: 0.5rem;
  accent-color: #007bff;
  width: 1rem;
  height: 1rem;
}
#knowledge-picker .knowledge-section .search-mode-section part-radio .form-check-label {
  font-size: 0.875rem;
  color: #495057;
  cursor: pointer;
  margin: 0;
  font-weight: 500;
  white-space: nowrap;
}
#knowledge-picker .knowledge-section .search-mode-section part-radio .form-check-input:checked ~ .form-check-label {
  color: #007bff;
  font-weight: 600;
}
#knowledge-picker .knowledge-section .selected-items-table {
  margin-bottom: 1rem;
  background-color: #ffffff;
  border-radius: 0.5rem;
  border: 1px solid #dee2e6;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}
#knowledge-picker .knowledge-section .selected-items-table .table-title {
  background-color: #f8f9fa;
  padding: 0.75rem 1rem;
  margin: 0;
  font-size: 0.875rem;
  font-weight: 600;
  color: #495057;
  border-bottom: 1px solid #dee2e6;
}
#knowledge-picker .knowledge-section .selected-items-table .table {
  margin-bottom: 0;
  font-size: 0.875rem;
}
#knowledge-picker .knowledge-section .selected-items-table .table th {
  background-color: #f8f9fa;
  border-bottom: 2px solid #dee2e6;
  font-weight: 600;
  color: #495057;
  padding: 0.5rem 0.75rem;
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
#knowledge-picker .knowledge-section .selected-items-table .table td {
  padding: 0.75rem;
  vertical-align: middle;
  border-bottom: 1px solid #f1f3f4;
}
#knowledge-picker .knowledge-section .selected-items-table .table td.knowledge-name, #knowledge-picker .knowledge-section .selected-items-table .table td.project-name {
  font-weight: 500;
  color: #212529;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
#knowledge-picker .knowledge-section .selected-items-table .table td.knowledge-project, #knowledge-picker .knowledge-section .selected-items-table .table td.project-description {
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
#knowledge-picker .knowledge-section .selected-items-table .table td.knowledge-format .badge {
  font-size: 0.7rem;
  padding: 0.25rem 0.5rem;
}
#knowledge-picker .knowledge-section .selected-items-table .table td.knowledge-size {
  font-family: "Monaco", "Menlo", "Ubuntu Mono", monospace;
  font-size: 0.8rem;
  color: #6c757d;
}
#knowledge-picker .knowledge-section .selected-items-table .table td .badge {
  font-size: 0.75rem;
  font-weight: 500;
}
#knowledge-picker .knowledge-section .selected-items-table .table td .badge.badge-warning {
  background-color: #ffc107;
  color: #212529;
  border: 1px solid #ffc107;
}
#knowledge-picker .knowledge-section .selected-items-table .table td .badge.badge-info {
  background-color: #17a2b8;
  color: white;
  border: 1px solid #17a2b8;
}
#knowledge-picker .knowledge-section .selected-items-table .table td .remove-btn {
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  transition: all 0.2s;
}
#knowledge-picker .knowledge-section .selected-items-table .table td .remove-btn:hover {
  background-color: #dc3545;
  border-color: #dc3545;
  color: white;
  transform: scale(1.05);
}
#knowledge-picker .knowledge-section .selected-items-table .table td .remove-btn i {
  font-size: 0.75rem;
}
#knowledge-picker .knowledge-section .selected-items-table .table tbody tr:hover {
  background-color: #f8f9fa;
}
#knowledge-picker .knowledge-section .selected-items-table .table tbody tr:last-child td {
  border-bottom: none;
}
#knowledge-picker .search-container {
  position: relative;
  margin-bottom: 1rem;
}
#knowledge-picker .search-container .search-label {
  display: block;
  font-size: 0.875rem;
  font-weight: 600;
  color: #495057;
  margin-bottom: 0.5rem;
}
#knowledge-picker .search-container .search-input-container {
  position: relative;
  display: flex;
  align-items: center;
}
#knowledge-picker .search-container .search-input-container .knowledge-search {
  width: 100%;
  padding-right: 2.5rem;
}
#knowledge-picker .search-container .search-input-container .knowledge-search:disabled {
  background-color: #e9ecef;
  opacity: 0.6;
}
#knowledge-picker .search-container .search-input-container .search-clear-btn {
  position: absolute;
  right: 0.25rem;
  padding: 0.25rem 0.5rem;
  border: none;
  background: transparent;
  color: #6c757d;
}
#knowledge-picker .search-container .search-input-container .search-clear-btn:hover {
  color: #495057;
  background-color: #f8f9fa;
}
#knowledge-picker .search-container .search-input-container .search-clear-btn i {
  font-size: 0.75rem;
}
#knowledge-picker .search-container .knowledge-dropdown {
  position: absolute;
  bottom: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #dee2e6;
  border-bottom: none;
  border-radius: 0.25rem 0.25rem 0 0;
  max-height: 200px;
  overflow-y: auto;
  z-index: 1000;
  box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.1);
  margin-bottom: 1px;
  margin-bottom: 1px;
}
#knowledge-picker .search-container .knowledge-dropdown .knowledge-option {
  padding: 0.75rem;
  border-bottom: 1px solid #f8f9fa;
  display: flex;
  flex-direction: row;
  gap: 5px;
  align-items: center;
  cursor: pointer;
  transition: background-color 0.2s;
}
#knowledge-picker .search-container .knowledge-dropdown .knowledge-option:hover {
  background-color: #e9ecef;
}
#knowledge-picker .search-container .knowledge-dropdown .knowledge-option:last-child {
  border-bottom: none;
}
#knowledge-picker .search-container .knowledge-dropdown .knowledge-option .knowledge-title {
  font-weight: 500;
  color: #212529;
  margin-bottom: 0.25rem;
  font-size: 0.9rem;
}
#knowledge-picker .search-container .knowledge-dropdown .knowledge-option .knowledge-info {
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem;
  margin-top: 0.5rem;
}
#knowledge-picker .search-container .knowledge-dropdown .knowledge-option .knowledge-info .badge {
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  font-weight: 500;
}
#knowledge-picker .search-container .knowledge-dropdown .knowledge-option .knowledge-info .badge.badge-warning {
  background-color: #ffc107;
  color: #212529;
  border: 1px solid #ffc107;
}
#knowledge-picker .search-container .knowledge-dropdown .knowledge-option .knowledge-info .badge.badge-secondary {
  background-color: #6c757d;
  color: white;
  border: 1px solid #6c757d;
}
#knowledge-picker .search-container .knowledge-dropdown .knowledge-option.project-option .project-title {
  font-weight: 500;
  color: #212529;
  margin-bottom: 0.25rem;
  font-size: 0.9rem;
}
#knowledge-picker .search-container .knowledge-dropdown .knowledge-option.project-option .project-description {
  font-size: 0.75rem;
  color: #6c757d;
  line-height: 1.3;
  max-height: 2.6em;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
#knowledge-picker .search-container .knowledge-dropdown .knowledge-option .knowledge-description {
  font-size: 0.875rem;
  color: #6c757d;
  line-height: 1.3;
  max-height: 2.6em;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
#knowledge-picker .kdb-button {
  border-radius: 50%;
  width: 36px;
  height: 36px;
  padding: 3px 0 0 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  box-shadow: 0 2px 4px rgba(0, 123, 255, 0.2);
  transition: all 0.2s ease;
  position: relative;
}
#knowledge-picker .kdb-button:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 123, 255, 0.3);
}
#knowledge-picker .kdb-button .badge {
  position: absolute;
  top: -5px;
  right: -5px;
  min-width: 18px;
  height: 18px;
  padding: 0 0.25rem;
  font-size: 0.7rem;
  font-weight: 600;
  border-radius: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}
#knowledge-picker .selected-items-flex {
  margin-bottom: 1rem;
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 0.375rem;
  border: 1px solid #dee2e6;
}
#knowledge-picker .selected-items-flex .table-title {
  margin-bottom: 0.75rem;
  font-weight: 600;
  color: #495057;
  font-size: 0.875rem;
  text-transform: uppercase;
  letter-spacing: 0.05rem;
}
#knowledge-picker .selected-items-flex .flex-table {
  display: flex;
  flex-direction: column;
  font-size: 0.875rem;
}
#knowledge-picker .selected-items-flex .flex-table .flex-table-header {
  display: flex;
  background: #fff;
  border-bottom: 2px solid #dee2e6;
  font-weight: 600;
  color: #495057;
}
#knowledge-picker .selected-items-flex .flex-table .flex-table-header .flex-cell {
  padding: 0.5rem 0.75rem;
}
#knowledge-picker .selected-items-flex .flex-table .flex-table-body {
  display: flex;
  flex-direction: column;
}
#knowledge-picker .selected-items-flex .flex-table .flex-table-row {
  display: flex;
  border-bottom: 1px solid #dee2e6;
  transition: background-color 0.15s ease-in-out;
}
#knowledge-picker .selected-items-flex .flex-table .flex-table-row:hover {
  background-color: rgba(0, 123, 255, 0.05);
}
#knowledge-picker .selected-items-flex .flex-table .flex-table-row .flex-cell {
  padding: 0.5rem 0.75rem;
  display: flex;
  align-items: center;
}
#knowledge-picker .selected-items-flex .flex-table .flex-cell.name-col {
  flex: 2;
  min-width: 150px;
  max-width: 250px;
}
#knowledge-picker .selected-items-flex .flex-table .flex-cell.name-col .knowledge-name,
#knowledge-picker .selected-items-flex .flex-table .flex-cell.name-col .project-name {
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
}
#knowledge-picker .selected-items-flex .flex-table .flex-cell.project-col, #knowledge-picker .selected-items-flex .flex-table .flex-cell.format-col, #knowledge-picker .selected-items-flex .flex-table .flex-cell.size-col, #knowledge-picker .selected-items-flex .flex-table .flex-cell.status-col {
  flex: 1;
  min-width: 100px;
  color: #6c757d;
}
#knowledge-picker .selected-items-flex .flex-table .flex-cell.mode-col {
  flex: 0 0 80px;
  justify-content: center;
  color: #6c757d;
}
#knowledge-picker .selected-items-flex .flex-table .flex-cell.description-col {
  flex: 2;
  min-width: 200px;
  color: #6c757d;
}
#knowledge-picker .selected-items-flex .flex-table .flex-cell.description-col .project-description {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
}
#knowledge-picker .selected-items-flex .flex-table .flex-cell.action-col {
  flex: 0 0 60px;
  justify-content: center;
}
#knowledge-picker .selected-items-flex .flex-table .badge {
  font-size: 0.75rem;
  font-weight: 500;
}
#knowledge-picker .selected-items-flex .flex-table .badge.badge-warning {
  background-color: #ffc107;
  color: #212529;
}
#knowledge-picker .selected-items-flex .flex-table .badge.badge-info {
  background-color: #17a2b8;
  color: #fff;
}
#knowledge-picker .selected-items-flex .flex-table .badge.badge-success {
  background-color: #28a745;
  color: #fff;
}
#knowledge-picker .selected-items-flex .flex-table .badge.badge-danger {
  background-color: #dc3545;
  color: #fff;
}
#knowledge-picker .selected-items-flex .flex-table .remove-btn {
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  transition: all 0.15s ease-in-out;
}
#knowledge-picker .selected-items-flex .flex-table .remove-btn:hover {
  transform: scale(1.05);
}
#knowledge-picker .selected-items-flex .flex-table .remove-btn i {
  font-size: 0.75rem;
}
@media (max-width: 768px) {
  #knowledge-picker .selected-items-flex .flex-table .flex-table-header {
    display: none;
  }
  #knowledge-picker .selected-items-flex .flex-table .flex-table-row {
    flex-direction: column;
    border: 1px solid #dee2e6;
    border-radius: 0.375rem;
    margin-bottom: 0.5rem;
  }
  #knowledge-picker .selected-items-flex .flex-table .flex-table-row .flex-cell {
    padding: 0.25rem 0.75rem;
    border-bottom: 1px solid #f0f0f0;
  }
  #knowledge-picker .selected-items-flex .flex-table .flex-table-row .flex-cell:last-child {
    border-bottom: none;
  }
  #knowledge-picker .selected-items-flex .flex-table .flex-table-row .flex-cell::before {
    content: attr(data-label) ": ";
    font-weight: 600;
    color: #495057;
    margin-right: 0.5rem;
  }
  #knowledge-picker .selected-items-flex .flex-table .flex-table-row .flex-cell.name-col::before {
    content: "Name: ";
  }
  #knowledge-picker .selected-items-flex .flex-table .flex-table-row .flex-cell.project-col::before {
    content: "Project: ";
  }
  #knowledge-picker .selected-items-flex .flex-table .flex-table-row .flex-cell.format-col::before {
    content: "Format: ";
  }
  #knowledge-picker .selected-items-flex .flex-table .flex-table-row .flex-cell.size-col::before {
    content: "Size: ";
  }
  #knowledge-picker .selected-items-flex .flex-table .flex-table-row .flex-cell.status-col::before {
    content: "Status: ";
  }
  #knowledge-picker .selected-items-flex .flex-table .flex-table-row .flex-cell.description-col::before {
    content: "Description: ";
  }
  #knowledge-picker .selected-items-flex .flex-table .flex-table-row .flex-cell.action-col::before {
    content: "";
  }
}
#knowledge-picker .search-container {
  position: relative;
  margin-bottom: 1rem;
}
#knowledge-picker .search-container .search-label {
  display: block;
  margin-bottom: 0.5rem;
  font-size: 0.875rem;
  font-weight: 600;
  color: #495057;
}
#knowledge-picker .search-container .knowledge-search {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #ced4da;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
#knowledge-picker .search-container .knowledge-search:focus {
  border-color: #007bff;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
#knowledge-picker .search-container .knowledge-search:disabled {
  background-color: #e9ecef;
  opacity: 1;
}
#knowledge-picker .search-container .knowledge-dropdown {
  position: absolute;
  bottom: 100%;
  left: 0;
  right: 0;
  margin-bottom: 0.25rem;
  background: #fff;
  border: 1px solid #ced4da;
  border-radius: 0.375rem;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
  max-height: 300px;
  overflow-y: auto;
  z-index: 1060;
}
#knowledge-picker .search-container .knowledge-dropdown .knowledge-option,
#knowledge-picker .search-container .knowledge-dropdown .project-option {
  padding: 0.75rem;
  cursor: pointer;
  border-bottom: 1px solid #f1f3f4;
  transition: background-color 0.15s ease-in-out;
}
#knowledge-picker .search-container .knowledge-dropdown .knowledge-option:hover,
#knowledge-picker .search-container .knowledge-dropdown .project-option:hover {
  background-color: #f8f9fa;
}
#knowledge-picker .search-container .knowledge-dropdown .knowledge-option:last-child,
#knowledge-picker .search-container .knowledge-dropdown .project-option:last-child {
  border-bottom: none;
}
#knowledge-picker .search-container .knowledge-dropdown .knowledge-option .knowledge-title,
#knowledge-picker .search-container .knowledge-dropdown .knowledge-option .project-title,
#knowledge-picker .search-container .knowledge-dropdown .project-option .knowledge-title,
#knowledge-picker .search-container .knowledge-dropdown .project-option .project-title {
  font-weight: 500;
  color: #212529;
  margin-bottom: 0.25rem;
  font-size: 0.875rem;
}
#knowledge-picker .search-container .knowledge-dropdown .knowledge-option .knowledge-info,
#knowledge-picker .search-container .knowledge-dropdown .project-option .knowledge-info {
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem;
  align-items: center;
}
#knowledge-picker .search-container .knowledge-dropdown .knowledge-option .knowledge-info .badge,
#knowledge-picker .search-container .knowledge-dropdown .project-option .knowledge-info .badge {
  font-size: 0.7rem;
  padding: 0.2rem 0.4rem;
}
#knowledge-picker .search-container .knowledge-dropdown .knowledge-option .knowledge-info .badge.badge-warning,
#knowledge-picker .search-container .knowledge-dropdown .project-option .knowledge-info .badge.badge-warning {
  background-color: #ffc107;
  color: #212529;
}
#knowledge-picker .search-container .knowledge-dropdown .knowledge-option .knowledge-info .badge.badge-secondary,
#knowledge-picker .search-container .knowledge-dropdown .project-option .knowledge-info .badge.badge-secondary {
  background-color: #6c757d;
  color: #fff;
}
#knowledge-picker .search-container .knowledge-dropdown .knowledge-option .project-description,
#knowledge-picker .search-container .knowledge-dropdown .project-option .project-description {
  font-size: 0.8rem;
  color: #6c757d;
  line-height: 1.4;
  margin-bottom: 0;
}
#knowledge-picker .search-container .knowledge-dropdown::-webkit-scrollbar {
  width: 6px;
}
#knowledge-picker .search-container .knowledge-dropdown::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}
#knowledge-picker .search-container .knowledge-dropdown::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}
#knowledge-picker .search-container .knowledge-dropdown::-webkit-scrollbar-thumb:hover {
  background: #a1a1a1;
}
#knowledge-picker .search-container .knowledge-dropdown .dropdown-empty-state {
  padding: 1rem;
  text-align: center;
  color: #6c757d;
  font-size: 0.875rem;
}
#knowledge-picker .search-container .knowledge-dropdown .dropdown-empty-state i {
  display: block;
  margin-bottom: 0.5rem;
  font-size: 1.5rem;
  color: #adb5bd;
}
#knowledge-picker .search-container .knowledge-dropdown .dropdown-loading-state {
  padding: 1rem;
  text-align: center;
  color: #6c757d;
  font-size: 0.875rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}
#knowledge-picker .search-container .knowledge-dropdown .dropdown-loading-state .spinner-border-sm {
  width: 1rem;
  height: 1rem;
  border-width: 0.1em;
}
#knowledge-picker .search-container .knowledge-dropdown .dropdown-loading-state .rag-progress-info {
  margin-top: 0.4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  font-size: 0.8rem;
  font-weight: 500;
}
#knowledge-picker .search-container .knowledge-dropdown .dropdown-loading-state .rag-progress-info .rag-progress-images {
  text-transform: capitalize;
}
.knowledge-section.bottom-position #knowledge-picker .search-container .knowledge-dropdown {
  bottom: auto;
  top: 100%;
  margin-bottom: 0;
  margin-top: 0.25rem;
}`;
const shadowOptions = { "mode": "open" };
let KnowledgePicker = class KnowledgePicker extends client_1.RWSViewComponent {
    constructor(wsService, signalService, popupService) {
        super();
        this.wsService = wsService;
        this.signalService = signalService;
        this.popupService = popupService;
        this.loading = false;
        this.knowledgeEntries = [];
        this.selectedKnowledge = [];
        this.knowledgeSearchTerm = '';
        this.filteredKnowledgeEntries = [];
        this.showKnowledgeDropdown = false;
        this.showKnowledgeSection = false;
        this.fullscan = false;
        this.awaiting = false;
        this.projects = [];
        this.searchMode = 'knowledge';
        this.searchModeOptions = [
            { label: 'knowledge.picker.search.knowledge', value: 'knowledge' },
            { label: 'knowledge.picker.search.projects', value: 'projects' }
        ];
        this.selectedProjects = [];
        this.filteredProjects = [];
        this.isBottomPosition = false;
        this.hasInteractedWithSearch = false;
        this.ragProgress = null;
        this.ragProgressMap = {};
        this.selectedIds = '';
        this.fullKnowledgeIds = '';
        this.forcedShow = 'false';
        this.selectedIdsArray = [];
        this.fullKnowledgeIdsArray = [];
        this.manuallySelectedIds = [];
        this.projectSelectedIds = new Map();
        this.label = 'Knowledge Base Entries';
        this.placeholder = 'Search knowledge entries...';
        this.showCheckbox = true;
        this.initialShow = false;
        this.absolute = false;
        this.onChange = () => { };
        this.filePickerSignal = null;
        this.currentKnowledgeListeners = new Set();
        this.awaitingKnowledgeId = null;
        this.handleEscKey = helpers_1.KnowledgeUIHelper.createEscKeyHandler(() => {
            if (this.showKnowledgeSection) {
                this.close();
            }
        });
        this.onSearchModeChange = async (event) => {
            const target = event.target;
            this.searchMode = target.value;
            this.knowledgeSearchTerm = '';
            this.showKnowledgeDropdown = false;
            this.selectedProjects = [];
            helpers_1.KnowledgeSearchManager.clearSearchTimeout('knowledge-search');
            if (this.searchMode === 'knowledge') {
                this.knowledgeEntries = [];
                this.filteredKnowledgeEntries = [];
            }
            else {
                if (this.projects.length === 0) {
                    await this.loadProjects();
                }
                this.knowledgeEntries = [];
                this.filteredKnowledgeEntries = [];
            }
        };
        // Chat integration handlers
        this.handleChatProjectSelected = (event) => {
            const customEvent = event;
            const { projectId, projectTitle } = customEvent.detail;
            let project = helpers_1.KnowledgeProjectHelper.findProjectById(this.projects, projectId);
            if (!project) {
                project = helpers_1.KnowledgeProjectHelper.createMinimalProject(projectId, projectTitle);
                this.projects.push(project);
            }
            this.searchMode = 'projects';
            if (!helpers_1.KnowledgeProjectHelper.isProjectSelected(this.selectedProjects, projectId)) {
                this.selectedProjects = [...this.selectedProjects, project];
                this.loadKnowledgeForProjects();
                this.showKnowledgeSection = true;
            }
        };
        this.handleChatProjectRemoved = (event) => {
            const customEvent = event;
            const { projectId } = customEvent.detail;
            const result = helpers_1.KnowledgeProjectHelper.removeProjectFromSelections(this.selectedProjects, this.selectedIdsArray, this.projectSelectedIds, projectId);
            this.selectedProjects = result.updatedProjects;
            this.selectedIdsArray = result.updatedSelectedIds;
            this.projectSelectedIds = result.updatedProjectMap;
            this.updateSelectedKnowledge();
            this.loadKnowledgeForProjects();
            if (this.selectedProjects.length === 0 && this.manuallySelectedIds.length === 0) {
                this.showKnowledgeSection = false;
            }
            this.notifyChange();
        };
    }
    async connectedCallback() {
        super.connectedCallback();
        this.filePickerSignal = this.signalService.getSignal('knowledge-picker-signal', { initialValue: null });
        this.showKnowledgeSection = this.initialShow;
        if (this.forcedShow === 'true') {
            this.showKnowledgeSection = true;
        }
        this.selectedIdsChanged();
        this.fullKnowledgeIdsChanged();
        this.setupEventHandlers();
        this.handleSignal();
        this.setupUIHandlers();
    }
    disconnectedCallback() {
        var _a;
        super.disconnectedCallback();
        // Clean up all current knowledge listeners first
        const listenersToClean = Array.from(this.currentKnowledgeListeners);
        for (const knowledgeId of listenersToClean) {
            helpers_1.KnowledgeWebSocketHelper.cleanupKnowledgeListener(knowledgeId);
        }
        // Remove document event listeners
        if (this.boundKnowledgeCreatedHandler) {
            document.removeEventListener('knowledge-created', this.boundKnowledgeCreatedHandler);
        }
        if (this.boundEscKeyHandler) {
            document.removeEventListener('keydown', this.boundEscKeyHandler);
        }
        helpers_1.KnowledgeSearchManager.clearAllTimeouts();
        helpers_1.KnowledgeUIHelper.clearAllDebounces();
        this.currentKnowledgeListeners.clear();
        (_a = this.filePickerSignal) === null || _a === void 0 ? void 0 : _a.destroy();
    }
    setupEventHandlers() {
        // Bind handlers once and store references for cleanup
        this.boundKnowledgeCreatedHandler = this.onKnowledgeCreated.bind(this);
        this.boundEscKeyHandler = this.handleEscKey;
        // Remove any existing listeners first (in case of reconnection)
        document.removeEventListener('knowledge-created', this.boundKnowledgeCreatedHandler);
        document.removeEventListener('keydown', this.boundEscKeyHandler);
        // Add fresh listeners
        document.addEventListener('knowledge-created', this.boundKnowledgeCreatedHandler);
        document.addEventListener('keydown', this.boundEscKeyHandler);
    }
    setupUIHandlers() {
        const positionHandler = helpers_1.KnowledgeUIHelper.createPositionHandler(() => {
            if (this.showKnowledgeDropdown) {
                this.checkViewportPosition();
            }
        });
        window.addEventListener('resize', positionHandler);
        window.addEventListener('scroll', positionHandler);
    }
    onKnowledgeCreated(e) {
        const knowledge = e.detail.knowledge;
        const needsProcessing = helpers_1.KnowledgeWebSocketHelper.needsRAGProcessing(knowledge.ragStatus);
        // Prevent duplicate processing by checking if we've already processed this knowledge
        const knowledgeExists = this.knowledgeEntries.some(k => k.id === knowledge.id);
        if (knowledgeExists) {
            return;
        }
        // Check if we already have a listener for this knowledge to prevent duplicates
        const knowledgeIdStr = knowledge.id.toString();
        if (this.currentKnowledgeListeners.has(knowledgeIdStr)) {
            return;
        }
        this.awaiting = needsProcessing;
        // Add the new knowledge to the list immediately for better UX
        this.knowledgeEntries = [...this.knowledgeEntries, knowledge];
        // Now select the knowledge (it exists in the list)
        this.selectKnowledge(knowledge.id);
        // If processing is needed, we'll reload after WebSocket completion
        // If no processing needed, reload immediately to ensure backend sync
        if (!needsProcessing) {
            this.awaiting = false;
            this.loading = false;
            // Small delay to ensure backend persistence, then reload
            setTimeout(() => {
                this.loadKnowledgeEntries();
            }, 500);
        }
        else {
            // For processing knowledge, set up WebSocket listener and reload after completion
            this.awaitingKnowledgeId = knowledge.id.toString();
            this.ragProgress = null;
            this.setupKnowledgeSpecificListener(knowledge.id);
        }
    }
    handleSignal() {
        this.filePickerSignal.value$.subscribe(async (newValue) => {
            var _a, _b;
            if (!newValue)
                return;
            switch (newValue.command) {
                case 'open':
                    this.showKnowledgeSection = true;
                    break;
                case 'close':
                    this.showKnowledgeSection = false;
                    break;
                case 'create':
                    this.showKnowledgeSection = true;
                    this.openKnowledgeModal(newValue.createPayload || {});
                    break;
                case 'pick':
                    if ((_a = newValue.knowledgeIds) === null || _a === void 0 ? void 0 : _a.length) {
                        for (const id of newValue.knowledgeIds) {
                            await this.selectKnowledge(id);
                        }
                        this.notifyChange();
                    }
                    break;
                case 'clear':
                    this.selectedIdsArray = [];
                    this.updateSelectedKnowledge();
                    this.filterKnowledgeEntries();
                    this.notifyChange();
                    break;
                case 'remove':
                    if ((_b = newValue.knowledgeIds) === null || _b === void 0 ? void 0 : _b.length) {
                        newValue.knowledgeIds.forEach(id => {
                            this.selectedIdsArray = helpers_1.KnowledgeSelectionManager.removeKnowledgeId(this.selectedIdsArray, id);
                        });
                        this.updateSelectedKnowledge();
                        this.filterKnowledgeEntries();
                        this.notifyChange();
                    }
                    break;
            }
        });
    }
    // Core selection methods
    async selectKnowledge(knowledgeId) {
        // Ensure we have the latest knowledge list
        await this.loadKnowledgeEntries();
        this.selectedIdsArray = helpers_1.KnowledgeSelectionManager.addKnowledgeId(this.selectedIdsArray, knowledgeId);
        const idString = String(knowledgeId);
        if (!this.manuallySelectedIds.includes(idString)) {
            this.manuallySelectedIds = [...this.manuallySelectedIds, idString];
        }
        this.updateSelectedKnowledge();
        this.filterKnowledgeEntries();
        this.notifyChange();
    }
    selectedIdsChanged() {
        var _a;
        this.selectedIdsArray = helpers_1.KnowledgeSelectionManager.parseIdString(this.selectedIds);
        this.manuallySelectedIds = [...this.selectedIdsArray];
        if (this.selectedIdsArray.length > 0 && this.knowledgeEntries.length === 0) {
            this.loadKnowledgeEntries();
        }
        if (((_a = this.knowledgeEntries) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            this.updateSelectedKnowledge();
            this.filterKnowledgeEntries();
        }
    }
    fullKnowledgeIdsChanged() {
        this.fullKnowledgeIdsArray = helpers_1.KnowledgeSelectionManager.parseIdString(this.fullKnowledgeIds);
    }
    // API methods using helpers
    async loadProjects() {
        try {
            this.setLoading(true);
            const result = await helpers_1.KnowledgeApiHelper.loadProjects(this.apiService);
            if (result.success) {
                this.projects = result.data;
                this.filterProjects();
            }
        }
        finally {
            this.setLoading(false);
        }
    }
    async loadKnowledgeEntries(searchQuery) {
        var _a;
        try {
            this.setLoading(true);
            const result = await helpers_1.KnowledgeApiHelper.loadKnowledgeEntries(this.apiService, searchQuery);
            if (result.success) {
                this.knowledgeEntries = result.data;
                if (this.selectedIdsArray.length > 0) {
                    this.updateSelectedKnowledge();
                }
                this.filterKnowledgeEntries();
                this.setupListenersForProcessingItems();
            }
            else {
                console.error('Failed to load knowledge entries:', result.error);
                (_a = this.notifyService) === null || _a === void 0 ? void 0 : _a.notify('Failed to load knowledge entries', 'error');
            }
        }
        finally {
            this.setLoading(false);
        }
    }
    // Search and filter methods
    async onKnowledgeSearchInput(event) {
        this.knowledgeSearchTerm = event.target.value;
        if (!this.hasInteractedWithSearch) {
            this.hasInteractedWithSearch = true;
            if (this.searchMode === 'knowledge') {
                await this.loadKnowledgeEntries();
            }
            else if (this.searchMode === 'projects' && this.projects.length === 0) {
                await this.loadProjects();
            }
        }
        if (this.searchMode === 'knowledge') {
            helpers_1.KnowledgeSearchManager.createDebouncedSearch('knowledge-search', async () => {
                await this.loadKnowledgeEntries(this.knowledgeSearchTerm);
                this.showKnowledgeDropdown = true;
            }, 300);
        }
        else {
            this.filterProjects();
            this.showKnowledgeDropdown = true;
        }
    }
    filterKnowledgeEntries() {
        this.filteredKnowledgeEntries = helpers_1.KnowledgeSearchManager.filterKnowledgeEntries(this.knowledgeEntries, this.selectedKnowledge, this.selectedIdsArray);
    }
    filterProjects() {
        this.filteredProjects = helpers_1.KnowledgeSearchManager.filterProjects(this.projects, this.selectedProjects);
    }
    // Selection handlers
    onKnowledgeSelect(knowledge) {
        const knowledgeId = knowledge.id.toString();
        if (!this.selectedIdsArray.includes(knowledgeId)) {
            this.selectedIdsArray = helpers_1.KnowledgeSelectionManager.addKnowledgeId(this.selectedIdsArray, knowledgeId);
            if (!this.manuallySelectedIds.includes(knowledgeId)) {
                this.manuallySelectedIds = [...this.manuallySelectedIds, knowledgeId];
            }
            this.updateSelectedKnowledge();
            this.knowledgeSearchTerm = '';
            this.showKnowledgeDropdown = false;
            this.filterKnowledgeEntries();
            this.notifyChange();
        }
    }
    onProjectSelect(project) {
        if (!this.selectedProjects.find(p => p.id === project.id)) {
            this.selectedProjects = [...this.selectedProjects, project];
            this.loadKnowledgeForProjects();
        }
        this.knowledgeSearchTerm = '';
        this.showKnowledgeDropdown = false;
    }
    async removeKnowledge(knowledgeId) {
        if (!await this.popupService.confirm('knowledge.picker.confirmRemove'.t())) {
            return;
        }
        this.selectedIdsArray = helpers_1.KnowledgeSelectionManager.removeKnowledgeId(this.selectedIdsArray, knowledgeId);
        this.fullKnowledgeIdsArray = helpers_1.KnowledgeSelectionManager.removeKnowledgeId(this.fullKnowledgeIdsArray, knowledgeId);
        this.manuallySelectedIds = helpers_1.KnowledgeSelectionManager.removeKnowledgeId(this.manuallySelectedIds, knowledgeId);
        for (const [projectId, knowledgeIds] of this.projectSelectedIds.entries()) {
            const updatedIds = helpers_1.KnowledgeSelectionManager.removeKnowledgeId(knowledgeIds, knowledgeId);
            this.projectSelectedIds.set(projectId, updatedIds);
        }
        this.fullKnowledgeIds = helpers_1.KnowledgeSelectionManager.arrayToIdString(this.fullKnowledgeIdsArray);
        this.updateSelectedKnowledge();
        this.filterKnowledgeEntries();
        this.notifyChange();
    }
    removeProject(project) {
        this.selectedProjects = this.selectedProjects.filter(p => p.id !== project.id);
        this.loadKnowledgeForProjects();
    }
    // Project integration
    async loadKnowledgeForProjects() {
        if (this.selectedProjects.length === 0) {
            this.selectedIdsArray = [...this.manuallySelectedIds];
            this.projectSelectedIds.clear();
            await this.loadKnowledgeEntries();
            this.updateSelectedKnowledge();
            this.filterKnowledgeEntries();
            this.notifyChange();
            return;
        }
        try {
            this.setLoading(true);
            const projectIds = this.selectedProjects.map(p => p.id.toString());
            const result = await helpers_1.KnowledgeApiHelper.loadKnowledgeForProjects(this.apiService, projectIds);
            if (result.success) {
                const projectKnowledgeEntries = result.data;
                await this.loadKnowledgeEntries();
                this.projectSelectedIds = helpers_1.KnowledgeProjectHelper.processProjectKnowledge(this.selectedProjects, projectKnowledgeEntries, this.projectSelectedIds);
                this.selectedIdsArray = helpers_1.KnowledgeSelectionManager.mergeSelections(this.manuallySelectedIds, this.projectSelectedIds);
                this.updateSelectedKnowledge();
                this.filterKnowledgeEntries();
                this.notifyChange();
            }
        }
        finally {
            this.setLoading(false);
        }
    }
    // UI methods
    async onKnowledgeSearchFocus() {
        if (!this.hasInteractedWithSearch) {
            this.hasInteractedWithSearch = true;
        }
        if (this.searchMode === 'knowledge') {
            if (this.knowledgeEntries.length === 0) {
                await this.loadKnowledgeEntries();
            }
            this.filterKnowledgeEntries();
        }
        else {
            if (this.projects.length === 0) {
                await this.loadProjects();
            }
            this.filterProjects();
        }
        this.showKnowledgeDropdown = true;
        this.checkViewportPosition();
    }
    onKnowledgeSearchBlur() {
        setTimeout(() => {
            this.showKnowledgeDropdown = false;
        }, 200);
    }
    close() {
        this.showKnowledgeSection = false;
    }
    toggleKnowledgeSection(event) {
        this.showKnowledgeSection = !this.showKnowledgeSection;
        if (!this.showKnowledgeSection) {
            this.knowledgeSearchTerm = '';
            this.showKnowledgeDropdown = false;
        }
        else {
            setTimeout(() => this.checkViewportPosition(), 10);
        }
    }
    toggleFullscan() {
        this.fullscan = !this.fullscan;
        this.$emit('fullscanChanged', { value: this.fullscan });
    }
    isKnowledgeInFullMode(knowledgeId) {
        return helpers_1.KnowledgeSelectionManager.isKnowledgeInFullMode(knowledgeId, this.fullKnowledgeIdsArray);
    }
    toggleKnowledgeFullMode(knowledgeId, event) {
        if (helpers_1.KnowledgeUIHelper.isDebouncedAction(knowledgeId, 100))
            return;
        event.preventDefault();
        event.stopPropagation();
        if (!helpers_1.KnowledgeUIHelper.isValidSwitchEvent(event))
            return;
        this.fullKnowledgeIdsArray = helpers_1.KnowledgeSelectionManager.toggleKnowledgeFullMode(knowledgeId, this.fullKnowledgeIdsArray, event.detail.checked);
        this.fullKnowledgeIds = helpers_1.KnowledgeSelectionManager.arrayToIdString(this.fullKnowledgeIdsArray);
        this.$emit('selectionChanged', {
            selectedIds: this.selectedIdsArray,
            fullKnowledgeIds: this.fullKnowledgeIdsArray,
            selectedKnowledge: this.selectedKnowledge,
            selectedProjects: this.selectedProjects
        });
    }
    openKnowledgeModal(payload = {}) {
        this.$emit(events_1.appEvents.openKnowledgeModal, payload);
    }
    // Utility methods
    formatFileSize(bytes) {
        return helpers_1.KnowledgeUIHelper.formatFileSize(bytes);
    }
    formatFileType(contentType, mimeType) {
        return helpers_1.KnowledgeUIHelper.formatFileType(contentType, mimeType);
    }
    updateSelectedKnowledge() {
        this.selectedKnowledge = helpers_1.KnowledgeSelectionManager.updateSelectedKnowledge(this.knowledgeEntries, this.selectedIdsArray);
    }
    notifyChange() {
        this.selectedIdsArray = helpers_1.KnowledgeSelectionManager.parseIdString(helpers_1.KnowledgeSelectionManager.arrayToIdString(this.selectedIdsArray));
        this.selectedIds = helpers_1.KnowledgeSelectionManager.arrayToIdString(this.selectedIdsArray);
        if (this.onChange) {
            this.onChange(this.selectedIdsArray);
        }
        this.$emit('selectionChanged', {
            selectedIds: this.selectedIdsArray,
            fullKnowledgeIds: this.fullKnowledgeIdsArray,
            selectedKnowledge: this.selectedKnowledge,
            selectedProjects: this.selectedProjects
        });
    }
    checkViewportPosition() {
        var _a;
        const knowledgeSection = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.knowledge-section');
        if (knowledgeSection) {
            const { isBottomPosition } = helpers_1.KnowledgeUIHelper.checkDropdownPosition(knowledgeSection);
            this.isBottomPosition = isBottomPosition;
            helpers_1.KnowledgeUIHelper.applyDropdownPositioning(knowledgeSection, isBottomPosition);
        }
    }
    async clearSearch() {
        helpers_1.KnowledgeSearchManager.clearSearchTimeout('knowledge-search');
        this.knowledgeSearchTerm = '';
        if (this.searchMode === 'knowledge') {
            await this.loadKnowledgeEntries();
        }
    }
    setLoading(loading) {
        this.loading = loading;
    }
    setupKnowledgeSpecificListener(knowledgeId) {
        const knowledgeIdStr = knowledgeId.toString();
        // Prevent duplicate listeners
        if (this.currentKnowledgeListeners.has(knowledgeIdStr)) {
            return;
        }
        // Add to tracking before setting up listener
        this.currentKnowledgeListeners.add(knowledgeIdStr);
        helpers_1.KnowledgeWebSocketHelper.setupKnowledgeListener(this.wsService, knowledgeId, async (responseKnowledgeId) => {
            // First reload the knowledge list to ensure we have the updated knowledge from API
            await this.loadKnowledgeEntries();
            // Then select the knowledge
            this.selectKnowledge(responseKnowledgeId);
            this.awaiting = false;
            this.loading = false;
            this.awaitingKnowledgeId = null;
            this.ragProgress = null;
            // Remove from tracking set - listener already cleaned up in helper
            this.currentKnowledgeListeners.delete(knowledgeIdStr);
        }, (responseKnowledgeId) => {
            this.awaiting = false;
            this.loading = false;
            this.awaitingKnowledgeId = null;
            this.ragProgress = null;
            // Remove from tracking set - listener already cleaned up in helper
            this.currentKnowledgeListeners.delete(knowledgeIdStr);
        }, this.notifyService, (progress) => {
            this.ragProgress = progress;
            this.ragProgressMap = { ...this.ragProgressMap, ['rag_progress_' + knowledgeId]: progress };
        });
    }
    /**
     * Set up WebSocket listeners for selected knowledge items that are still processing
     */
    setupListenersForProcessingItems() {
        for (const knowledge of this.selectedKnowledge) {
            if (helpers_1.KnowledgeWebSocketHelper.needsRAGProcessing(knowledge.ragStatus)) {
                const knowledgeIdStr = knowledge.id.toString();
                if (!this.currentKnowledgeListeners.has(knowledgeIdStr)) {
                    this.setupKnowledgeSpecificListener(knowledge.id);
                }
            }
        }
    }
    showItemPercentage(knowledgeId) {
        const progress = this.ragProgressMap['rag_progress_' + knowledgeId];
        if (!progress)
            return '';
        const imagesLabel = progress.images ? (' ' + 'knowledge.statusInfo.images'.t()) : '';
        return `${imagesLabel}: ${progress.percentage.toFixed(2)}%`;
    }
};
exports.KnowledgePicker = KnowledgePicker;
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], KnowledgePicker.prototype, "loading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], KnowledgePicker.prototype, "knowledgeEntries", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], KnowledgePicker.prototype, "selectedKnowledge", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], KnowledgePicker.prototype, "knowledgeSearchTerm", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], KnowledgePicker.prototype, "filteredKnowledgeEntries", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], KnowledgePicker.prototype, "showKnowledgeDropdown", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], KnowledgePicker.prototype, "showKnowledgeSection", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], KnowledgePicker.prototype, "fullscan", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], KnowledgePicker.prototype, "awaiting", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], KnowledgePicker.prototype, "projects", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], KnowledgePicker.prototype, "searchMode", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_d = typeof Array !== "undefined" && Array) === "function" ? _d : Object)
], KnowledgePicker.prototype, "searchModeOptions", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], KnowledgePicker.prototype, "selectedProjects", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], KnowledgePicker.prototype, "filteredProjects", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], KnowledgePicker.prototype, "isBottomPosition", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], KnowledgePicker.prototype, "hasInteractedWithSearch", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], KnowledgePicker.prototype, "ragProgress", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_e = typeof Record !== "undefined" && Record) === "function" ? _e : Object)
], KnowledgePicker.prototype, "ragProgressMap", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], KnowledgePicker.prototype, "selectedIds", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], KnowledgePicker.prototype, "fullKnowledgeIds", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], KnowledgePicker.prototype, "forcedShow", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], KnowledgePicker.prototype, "selectedIdsArray", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], KnowledgePicker.prototype, "fullKnowledgeIdsArray", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], KnowledgePicker.prototype, "manuallySelectedIds", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_f = typeof Map !== "undefined" && Map) === "function" ? _f : Object)
], KnowledgePicker.prototype, "projectSelectedIds", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], KnowledgePicker.prototype, "label", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], KnowledgePicker.prototype, "placeholder", void 0);
__decorate([
    (0, client_1.attr)({ attribute: 'show-checkbox', mode: 'boolean' }),
    __metadata("design:type", Boolean)
], KnowledgePicker.prototype, "showCheckbox", void 0);
__decorate([
    (0, client_1.attr)({ attribute: 'initial-show', mode: 'boolean' }),
    __metadata("design:type", Boolean)
], KnowledgePicker.prototype, "initialShow", void 0);
__decorate([
    (0, client_1.attr)({ attribute: 'absolute', mode: 'boolean' }),
    __metadata("design:type", Boolean)
], KnowledgePicker.prototype, "absolute", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Function)
], KnowledgePicker.prototype, "onChange", void 0);
exports.KnowledgePicker = KnowledgePicker = __decorate([
    (0, client_1.RWSView)('knowledge-picker', null, { template: rwsTemplate, styles, options: { shadowOptions } }),
    __param(0, (0, client_1.RWSInject)(WSService_audio_1.default)),
    __param(1, (0, client_1.RWSInject)(SignalService_1.default)),
    __param(2, (0, client_1.RWSInject)(PopupService_1.default)),
    __metadata("design:paramtypes", [typeof (_a = typeof WSService_audio_1.WSServiceAudioInstance !== "undefined" && WSService_audio_1.WSServiceAudioInstance) === "function" ? _a : Object, typeof (_b = typeof SignalService_1.SignalServiceInstance !== "undefined" && SignalService_1.SignalServiceInstance) === "function" ? _b : Object, typeof (_c = typeof PopupService_1.PopupServiceInstance !== "undefined" && PopupService_1.PopupServiceInstance) === "function" ? _c : Object])
], KnowledgePicker);
KnowledgePicker.defineComponent();
